const Calender = () => <h1>Calendar Page</h1>;
export default Calender;
